import React, { useEffect, useState } from 'react';

import './style.scss';

const SearchHeader = ({ data }) => {
  const [items, setItems] = useState([]);
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    if (!data || typeof data.results === 'undefined') return;

    const currentPageNumber = data.results.hits.page.pageNumber;
    const dataChanged = JSON.stringify(currentData) !== JSON.stringify(data);

    if (dataChanged) {
      if (items.length === 0 || currentPageNumber === 0) {
        setItems([...data.results.hits.items]);
      } else {
        setItems([...items, ...data.results.hits.items]);
      }

      setCurrentData(data);
    }
  }, [data, currentData]);

  const itemsFound = items.reduce((value, item) => {
    if (item.inside_area === 0) {
      return value;
    }
    return value + 1;
  }, 0);

  if (itemsFound === 0) {
    return (
      <div className="SearchHeader--no-results">
        <h2>Er zijn helaas (nog) geen activiteiten binnen jouw zoekopdracht</h2>
        <a href="https://formulieren.oranjefonds.nl/updates_nldoet_vrijwilligers_nodig_in_mijn_gemeente" rel="noreferrer" target="_blank">Op de hoogte blijven van (nieuwe) activiteiten in mijn buurt</a>
      </div>
    );
  }

  return (
    <h2 className="SearchHeader">{itemsFound} activiteiten gevonden</h2>
  );
};

export default SearchHeader;
